import { createContext, useState } from 'react';
import api from 'services/api';

export const GarantiasContext = createContext();

export const GarantiasProvider = ({ children }) => {
  const [garantias, setGarantias] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter: {},
    page: 0,
    size: 10,
  });
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);

  const getGarantias = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: garantias?.filter,
        page: garantias?.page,
        size: garantias?.size,
        order: garantias?.order,
        ...payload,
      });
      setGarantias((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postConclusao = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Documento/Midia', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const getConsultaPeca = async ({ params, cb }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get('/Comercial/Garantias/Consulta', {
        params,
      });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <GarantiasContext.Provider
      value={{
        garantias,
        getLoading,
        getGarantias,
        postLoading,
        postConclusao,
        getConsultaPeca,
      }}
    >
      {children}
    </GarantiasContext.Provider>
  );
};
